import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import query from '@/plugins/graphql/queries/me.gql';
import ActionButton from '@/components/action_button/Index.vue';
import PageTransition from '@/components/page_transition/Index.vue';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import AccountSettingDetail from '@/components/v2/AccountSettingDetail.vue';
import UserSettingResetPasswordConfirm from '@/components/v2/UserSettingResetPasswordConfirm.vue';
import { LONGDATE_FORMAT } from '@/helpers/constants/app';
import AccountDetails from '@/components/v2/AccountDetails.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let UserProfile = class UserProfile extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.me = null;
        this.userUuid = null;
        this.isRequestOnProcess = true;
    }
    get formatBirthdate() {
        return moment(this.me.birthdate).format(LONGDATE_FORMAT);
    }
    get detailStyle() {
        if (this.smAndUp) {
            return 'width: 50%';
        }
        return '';
    }
    onEdit() {
        this.$router.push({ name: 'profile-update' });
    }
    onResetPassword() {
        this.userUuid = this.me.uuid;
    }
    goToMyMiniApps() {
        this.$router.push('/apps');
    }
    mounted() {
        this.$apollo.queries.me.refetch();
    }
};
UserProfile = __decorate([
    Component({
        components: {
            PageTransition,
            BaseOverlayLoader,
            AccountSettingDetail,
            UserSettingResetPasswordConfirm,
            ActionButton,
            AccountDetails,
        },
        apollo: {
            me: {
                query,
                update(data) {
                    if (data.me) {
                        this.isRequestOnProcess = false;
                        return data.me;
                    }
                },
                skip() {
                    return !this.$store.state.session.token;
                },
            },
        },
    })
], UserProfile);
export default UserProfile;
